module.exports = __webpack_public_path__ + "img/stage-bg.2b27682b.jpg";